import script from "./OtpPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpPage.vue?vue&type=script&setup=true&lang=js"

import "./OtpPage.vue?vue&type=style&index=0&id=6ac76d68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac76d68"]])

export default __exports__